import React from 'react'
import styled from 'react-emotion'
import { ShadowBox } from '../../styles'
import Loader from './Loader'

const Wrapper = styled(ShadowBox)`
  margin-bottom: 20px;
  .setting-box-read-only {
    display: ${props => props.editMode ? 'none' : 'block'};
    @media (max-width: 992px) {
      width: 100%;
    }
  }
  .setting-box-edit {
    display: ${props => props.editMode ? 'block' : 'none'};
    @media (max-width: 992px) {
      width: 100%;
    }
  }
`

const Header = styled('h3')`
  background-color: #e7e3db;
  padding: 20px;
  margin: -15px -15px 15px -15px !important;
`

const Footer = styled('div')`  
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  button {
    margin: 5px;
    font-size: 1.4rem;
    line-height: 1.3;
    padding: 6px 48px;
    min-height: 36px;
  } 
  @media (max-width: 992px) {
    flex-direction: column;
    button  {
      width: 100%;
      margin-left: 0;
    } 
  }
`

const SettingBox = ({ header, children, fetching, ...props }) => {
  const editMode = props.hasOwnProperty("readonly")
    ? !props.readonly
    : props.editMode

  return (
    <Wrapper {...props} editMode={editMode}>
      <Header>{header}</Header>
      {fetching ? <Loader /> : children}
    </Wrapper>
  )
}

const ReadOnly = ({ children }) => (
  <div className="setting-box-read-only">{children}</div>
)

const Edit = ({ children }) => (
  <div className="setting-box-edit">{children}</div>
)

SettingBox.Edit = Edit
SettingBox.ReadOnly = ReadOnly
SettingBox.Footer = Footer

export default SettingBox